"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _IdeationStatus = _interopRequireDefault(require("@insided/deprecated-preact-components/topic-list-view/IdeationStatus"));

var _TopicContent = _interopRequireWildcard(require("@insided/deprecated-preact-components/topic-list-view/TopicContent"));

var _TopicLabel = _interopRequireDefault(require("@insided/deprecated-preact-components/topic-list-view/TopicLabel"));

var _LazyImage = _interopRequireDefault(require("@insided/shared/uikit/LazyImage"));

var _StatusPill = _interopRequireDefault(require("@insided/shared/uikit/StatusPill"));

var _common = require("@insided/shared/utils/common");

var _contentType = require("@insided/shared/utils/contentType");

var _TopicFooter = _interopRequireDefault(require("./TopicFooter"));

var _ContentStatus = require("../ContentStatus");

var _TopicContainer = _interopRequireDefault(require("./TopicContainer"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var featuredImageComponent = function featuredImageComponent(featuredImage, attachmentCdn, altText, topicTitle) {
  return (0, _preact.h)(_LazyImage.default, {
    type: "img",
    src: (0, _absoluteUrlRuntime.resolveUrl)((0, _TopicContent.getImageUrl)(featuredImage, '480', attachmentCdn)),
    className: "thread-list-block__featured-image-link topic-image",
    alt: altText,
    title: topicTitle
  });
};

var TopicInfo = function TopicInfo(props) {
  var topic = props.topic,
      showUnsubscribeBtn = props.showUnsubscribeBtn,
      userId = props.userId,
      attachmentCdn = props.attachmentCdn,
      clickCallback = props.clickCallback,
      ariaKey = props.ariaKey,
      handleFavoriteRemoval = props.handleFavoriteRemoval,
      lastContributor = props.lastContributor;
  var featuredImage = topic.featuredImage,
      featuredImageAltText = topic.featuredImageAltText,
      topicUrl = topic.topicUrl,
      contentType = topic.contentType,
      topicTitle = topic.title;

  var isBugContentTypeEnabled = _common.common.isModuleActive('bugContentType');

  var renderStatusBadge = function renderStatusBadge() {
    if (contentType === 'idea') {
      return (0, _preact.h)(_IdeationStatus.default, {
        topic: topic
      });
    }

    if ((0, _contentType.isConversationOrDiscussion)(contentType) && isBugContentTypeEnabled && topic !== null && topic !== void 0 && topic.bugStatus) {
      var bugStatus = topic.bugStatus;
      return (0, _preact.h)(_StatusPill.default, {
        label: bugStatus.name,
        backgroundColor: bugStatus.backgroundColor,
        textColor: bugStatus.textColor
      });
    }

    return (0, _preact.h)(_ContentStatus.TopicTooltip, {
      topic: topic
    });
  };

  return (0, _preact.h)("div", null, (0, _preact.h)(_TopicContainer.default, {
    anchorProps: {
      id: ariaKey,
      href: topicUrl === null || topicUrl === void 0 ? void 0 : topicUrl.destination,
      className: 'qa-topic-title'
    },
    clickCallback: clickCallback,
    infoSlot: featuredImage && featuredImageComponent(featuredImage, attachmentCdn, featuredImageAltText, topicTitle)
  }, (0, _preact.h)("div", {
    className: "thread-list-block__title"
  }, (0, _preact.h)("span", {
    className: "thread-list-block__title-link"
  }, topicTitle), (0, _preact.h)(_TopicLabel.default, {
    topic: topic
  }), renderStatusBadge()), (0, _preact.h)(_TopicContent.default, {
    topic: _objectSpread(_objectSpread({}, topic), {
      url: topicUrl.destination
    })
  })), (0, _preact.h)(_TopicFooter.default, {
    topic: topic,
    lastContributor: lastContributor,
    showUnsubscribeBtn: showUnsubscribeBtn,
    handleFavoriteRemoval: handleFavoriteRemoval,
    userId: userId,
    extraSpacing: true
  }));
};

var _default = TopicInfo;
exports.default = _default;